export default {
  reserveBtnText: "Unduh\nGame",
  pageTitle: "RO World Journey Halaman Co-Creation Pemain",
  loginBtn: "Masuk",
  logoutBtn: "[ Keluar ]",
  joinActivityText: '<span class="number">${n}</span> pemain telah bergabung',
  search: "Cari",
  searchPlaceholder: "Masukkan nama kreator / kata kunci",
  filter: "Filter",
  sortBy: "Urutkan",
  sortByTime: "Terbaru",
  sortByHot: "Populer",
  releaseTime: "Waktu Rilis",
  noLimit: "Semua",
  oneDay: "Dalam 1 Hari",
  oneWeek: "Dalam 1 Minggu",
  reset: "Reset",
  loginTip: "Login untuk bergabung dalam co-creation",
  nowLoginBtn: "Login Sekarang",
  home: "Kembali ke Beranda",
  creativeCenter: "Karya Saya",
  developmentLog: "Log Dev",
  devSectionSubtitle: "Untuk semua yang menanti pertemuan kembali dengan RO",
  feedback: "Masukan",
  feedbackPopupTitle: "Kirim Masukan",
  feedbackAccount: "Akun Saat Ini:",
  notLoggedIn: "Belum login",
  feedbackEmail: "Email:",
  feedbackEmailPlaceholder: "Masukkan email kontak Anda",
  feedbackCategory: "Kategori:",
  feedbackCategoryPlaceholder: "Pilih kategori masukan",
  feedbackCat1: "Bug Game",
  feedbackCat2: "Permintaan Fitur",
  feedbackCat3: "Optimasi Sistem",
  feedbackCat4: "Lainnya",
  feedbackContent: "Isi Masukan:",
  feedbackContentPlaceholder: "Harap jelaskan masukan Anda secara detail",
  feedbackAttachment: "Lampiran",
  feedbackAttachmentLimit: "Maksimal 3 lampiran",
  feedbackAddAttachment: "Tambah Lampiran",
  feedbackErrEmail: "Harap masukkan email",
  feedbackErrCategory: "Harap pilih kategori",
  feedbackErrContent: "Harap masukkan isi masukan",
  feedbackErrFileSize: "Ukuran file tidak boleh melebihi 10MB",
  feedbackErrFileType: "Hanya mendukung gambar (JPG/PNG) dan dokumen (PDF/DOC/DOCX)",
  exitConfirmTitle: "Pemberitahuan",
  exitConfirmLine1: "Konten tidak dapat disimpan setelah keluar",
  exitConfirmLine2: "Tetap keluar?",
  publishTime: "Diterbitkan: ",
  selectType: "Pilih Tipe",
  createType1: "Desain Kostum",
  createType2: "Desain Aksesori",
  createType3: "Event Meme",
  createType4: "Kenangan RO Saya",
  createType5: "Berbagi Foto Keren",
  createType6: "Poring Saya",
  createType7: "Berbagi Class",
  ugcJoinBtn: 'Ikut Sekarang',
  kolPopupTitle: "Pendaftaran KOL",
  kolAccount: "Akun Saat Ini:",
  kolEmail: "Email:",
  kolEmailPlaceholder: "Masukkan email",
  kolDiscordId: "ID Discord:",
  kolDiscordIdPlaceholder: "Masukkan ID Discord",
  kolSpecialty: "Keahlian Kreatif:",
  kolSpecialtyPlaceholder: "Pilih keahlian kreatif",
  kolSpecialty1: "Panduan Strategi",
  kolSpecialty2: "Desain Seni",
  kolSpecialty3: "Produksi Video",
  kolSpecialty4: "Lainnya",
  kolWorkUrl: "Link Karya Sebelumnya:",
  kolWorkUrlPlaceholder: "Masukkan link karya sebelumnya, pisahkan beberapa link dengan koma",
  kolFollower: "Jumlah subscriber:",
  kolFollowerPlaceholder: "Masukkan jumlah subscriber saat ini",
  kolSubmitBtn: "Serahkan",
  kolErrEmail: "Harap masukkan email",
  kolErrEmailFormat: "Harap masukkan format email yang valid",
  kolErrDiscord: "Harap masukkan ID Discord",
  kolErrSpecialty: "Harap pilih keahlian kreatif",
  kolErrWorkUrl: "Harap masukkan link karya sebelumnya",
  kolErrFollower: "Harap masukkan jumlah subscriber yang valid",
  kolSubmitSuccess: "Pendaftaran berhasil dikirim",
  feedbackSuccessTitle: 'Novice yang terhormat',
  feedbackSuccessContent: 'Selamat! Pengajuanmu berhasil dikirim!',
  kolSubmitFail: "Pengiriman gagal, coba lagi nanti",
  kolNetworkFail: "Pengiriman gagal, periksa koneksi jaringan Anda",
  kolSubtitle: "Bergabung dengan Tim Kreator",
  kolContent: "Di sini kamu tidak hanya bisa bertukar pikiran dengan para kreator hebat, tapi juga mendapat hadiah eksklusif yang melimpah! Ayo klik daftar sekarang!",
  kolViewBtn: "Lihat",
  lotterySubTitle: 'Ikuti event kolaborasi untuk mendapatkan poin,<br><span class="red">menangkan item virtual eksklusif dan merchandise fisik menarik!</span>',
  drawSubTitle: 'Menampilkan Sebagian Hadiah Utama',
  physicalRewardsLabel: 'Hadiah Fisik:',
  inGameRewardsLabel: 'Hadiah In-game:',
  myPoints: "Poin Saya: ",
  viewPointDetail: "Lihat Detail Poin >>",
  currentTitle: "Gelar Saat Ini: ",
  taskRuleBtn: "Aturan Event",
  taskBtnFinished: "Selesai",
  taskBtnEnded: "Berakhir",
  taskBtnGo: "Pergi Sekarang",
  taskDailyLoginTitle: "Login Harian Pertama",
  taskDailyLoginDesc: "Halaman Login Harian (5 Poin)",
  taskReserveTitle: "Unduh Game",
  taskReserveDesc: "Selesaikan unduhan game pertama kali (25 poin)",
  taskFeedbackTitle: "Kirim Masukan",
  taskFeedbackDesc: "Kirim masukan pertama harian (15 poin)",
  taskRoMemoryTitle: "Kiriman My Poring",
  taskRoMemoryDesc: "Kiriman pertama harian (25 poin), batas mingguan 50 poin",
  taskCostumeTitle: "Kiriman Berbagi Profesi",
  taskCostumeDesc: "Kiriman pertama harian (25 poin), batas mingguan 25 poin",
  taskPhotoTitle: "Kirim Foto Cantik",
  taskPhotoDesc: "Kiriman pertama harian (25 poin), batas mingguan 50 poin",
  taskLikeOtherTitle: "Like Karya Orang Lain",
  taskLikeOtherDesc: "Setiap like mendapat 0,5 poin, batas harian 5 poin ({n}/5 poin)",
  taskLikeMyTitle: "Karya Mendapat Like",
  taskLikeMyDesc: "Dapat 1 poin per like, batas mingguan 200 poin ({n}/200 poin)",
  taskFbTitle: "Ikuti Facebook",
  taskFbDesc: "Bergabung dengan Facebook Resmi (10 poin)",
  taskDcTitle: "Ikuti Discord",
  taskDcDesc: "Ikuti Discord Resmi (10 poin)",
  taskYtbTitle: "Ikuti YouTube",
  taskYtbDesc: "Ikuti YouTube Resmi (10 poin)",
  taskLineTitle: "Ikuti LINE",
  taskLineDesc: "Ikuti LINE Resmi (10 poin)",
  ugcTabContent6: "Hitam putih, pink, atau dibuat dari kode...|seperti apa Poring di hatimu?|Ayo bagikan karya Poring buatanmu|dan biarkan kelucuan menguasai Midgard!|Aturan Partisipasi:|Bagikan Poring buatanmu sendiri.|Format bebas, termasuk gambar tangan,|karya berbasis kode, dan lainnya.",
  ugcTabContent7: "Bagikan build skill dan momen pertarungan terbaikmu|agar lebih banyak petualang bisa melihat highlight Class-mu!|Aturan Partisipasi:|Upload screenshot pertarungan|atau build skill Class apa pun di dalam game.",
  ugcTabContent5: "Dunia terbuka tanpa batas adalah studio foto terbaik.|Pamerkan gaya outfit unikmu, abadikan pemandangan indah,|dan rekam momen seru milikmu di Midgard!|Aturan Partisipasi:|Upload screenshot pewarnaan|atau mix-and-match outfit dalam game + pemandangan.",
  communicationType1: "Masukan",
  communicationType2: "Log Dev",
  inputTitle: "Masukkan judul",
  inputContent: "Masukkan konten",
  uploadImage: "Edit Gambar",
  uploadImageTip: "Seret untuk mengurutkan",
  addImage: "Tambah",
  creationBtnText: "Saya Ingin Posting",
  publish: "Terbitkan",
  loading: "Memuat",
  publishSuccess: "Diterbitkan, menunggu peninjauan",
  commonTip: "Silakan coba lagi nanti",
  editSaveTip: "Simpan perubahan ini?",
  saveCancel: "Buang",
  saveConfirm: "Simpan",
  myCreative: "Kreasi Saya",
  deleteTip: "Hapus kreasi ini?",
  confirmBtn: "Konfirmasi",
  cancelBtn: "Batal",
  submitBtn: "Kirim",
  tipPopupTitle: "Pemberitahuan",
  loginPopupTitle: "Pemberitahuan",
  scoreDetailTitle: "Poin Saya",
  lotterySuccTitle: "Selamat",
  physicalAwardTitle: "Info Pengiriman",
  physicalCheckTitle: "Pemberitahuan",
  vtCodeTitle: "Diambil",
  realNameLabel: "Nama Lengkap",
  phoneLabel: "Nomor HP",
  areaCodeLabel: "Kode Area",
  addressLabel: "Alamat Pengiriman",
  countryLabel: "Negara/Wilayah",
  postalCodeLabel: "Kode Pos",
  confirmShippingTip: "Info pengiriman tidak dapat diubah setelah dikonfirmasi.<br />Apakah Anda yakin?",
  submitSuccessTip: "Berhasil dikirim",
  scoreItemLabel: "Item",
  scoreChangeLabel: "Poin",
  scoreTimeLabel: "Waktu",
  lotteryDrawLabel: "Undian Poin",
  auditResultNotice: "Hasil Peninjauan",
  auditResultContent:
    "Pemain yang terhormat,<br/><br/>Kreasi Anda berjudul 【${title}】 yang dikirim pada ${time} tidak lulus peninjauan. Silakan revisi dan kirim ulang.",
  auditReason: "Alasan: ",
  auditTime: "Waktu Peninjauan: ",
  emptyNotice: "Tidak ada konten",
  emptyWorks: "Jadilah yang pertama membuat!",
  viewImage: "Klik untuk melihat aslinya",
  createPopupTitle: "Terbitkan Kreasi",
  gameName: "RO World Journey",
  gameType: "Open-World RO",
  loadingMore: "Gulir untuk memuat lebih banyak",
  noMoreData: "Tidak ada konten lagi",
  auditPass: "Diterbitkan",
  auditFail: "Ditolak",
  auditState: "Dalam Peninjauan",
  ugcRuleRules: `Aturan Event Pengiriman UGC Ragnarok: The New World

1) Persyaratan Konten Kiriman
1. Semua konten kiriman harus berkaitan dengan Ragnarok: The New World dan merupakan karya original dari pengirim. Plagiarisme, pencurian, penyalinan, atau penggunaan materi milik orang lain tanpa izin sangat dilarang.
2. Konten kiriman harus sesuai dengan tema jalur yang ditentukan dan persyaratan event.
3. Apabila konten kiriman mengandung materi, musik, gambar, atau konten pihak ketiga yang dilindungi hak cipta, pengirim wajib memastikan telah memperoleh izin yang sah. Segala sengketa dan tanggung jawab yang timbul akibat masalah hak cipta sepenuhnya ditanggung oleh pengirim.
4. Pihak penyelenggara berhak meninjau semua konten kiriman. Konten yang melanggar aturan, tidak pantas, berkualitas rendah, tidak relevan dengan event, atau tidak memenuhi persyaratan event dapat ditolak untuk ditampilkan, didiskualifikasi dari event, dan tidak akan mendapat poin atau hadiah terkait.

2) Tampilan Karya dan Interaksi
1. Karya yang telah lulus peninjauan akan ditampilkan di "Galeri Karya" pada halaman event.
2. Pemain dapat melihat, menyukai, dan berinteraksi dengan karya yang ditampilkan.
3. Pihak penyelenggara berhak menyesuaikan urutan tampilan karya, konten yang direkomendasikan, dan format tampilan sesuai kebutuhan operasional event.

3) Lisensi Penggunaan Karya
1. Dengan berhasil mengirimkan karya, pengirim dianggap telah menyetujui pemberian lisensi penggunaan kepada pihak resmi Ragnarok: The New World yang bersifat global, permanen, tidak dapat dicabut, non-eksklusif, dan bebas royalti.
2. Pihak penyelenggara dapat menggunakan konten kiriman di dalam maupun luar game, situs resmi, platform media sosial, materi pemasaran, promosi event, produksi merchandise, serta konten turunan lainnya yang relevan.
3. Untuk memenuhi kebutuhan promosi dan operasional, pihak penyelenggara berhak melakukan pengeditan, optimasi, adaptasi, atau reproduksi konten kiriman sesuai kebutuhan.
4. Pengirim tetap memegang hak cipta dan hak atribusi atas karya originalnya.

4) Partisipasi Event dan Ketentuan Hadiah
1. Pemain wajib menyelesaikan semua operasi terkait event dalam batas waktu yang ditentukan, termasuk namun tidak terbatas pada pengiriman karya, perolehan dan penukaran poin, pengambilan hadiah, serta pengisian informasi pengiriman.
2. Apabila pemain tidak menyelesaikan operasi terkait dalam batas waktu yang ditentukan, maka dianggap secara otomatis melepaskan hak, poin, atau hadiah yang bersangkutan.
3. Hadiah yang tidak diambil, poin yang tidak digunakan, atau informasi yang tidak dilengkapi dalam batas waktu yang ditentukan tidak akan diproses ulang atau dipulihkan oleh pihak penyelenggara.
4. Apabila pemain mengisi informasi pribadi yang salah, tidak lengkap, tidak valid, atau tidak diperbarui sehingga mengakibatkan ketidakmampuan untuk berpartisipasi dalam event atau mengambil hadiah, pihak penyelenggara tidak bertanggung jawab atas hal tersebut.
5. Apabila akun mengalami anomali, diretas, terjadi masalah perangkat, masalah jaringan, atau pelanggaran aturan game yang mengakibatkan pembatasan atau pemblokiran akun sehingga mempengaruhi partisipasi event atau pengambilan hadiah, pihak penyelenggara tidak bertanggung jawab. Apabila akun diblokir selama event berlangsung, poin yang belum digunakan dan hadiah yang belum diambil akan otomatis hangus.

5) Pencegahan Kecurangan dan Penanganan Pelanggaran
Pihak penyelenggara akan memantau perilaku partisipasi event secara ketat. Apabila terdeteksi pelanggaran berikut, tindakan segera akan diambil, termasuk namun tidak terbatas pada pemblokiran akun yang terlibat, pencabutan semua hak partisipasi event, penarikan kembali hadiah yang telah diberikan (termasuk item virtual yang telah digunakan), dan penuntutan hukum:
1. Menggunakan cara apapun untuk mendaftarkan akun massal (satu orang, perangkat sama, atau IP sama dengan banyak akun) untuk berpartisipasi dalam event.
2. Memanfaatkan celah program, alat tidak resmi, atau cara tidak normal apapun untuk memperoleh poin secara curang.
3. Menggunakan perangkat lunak ilegal pihak ketiga, cheat, atau alat bantu untuk mengganggu jalannya event.
4. Segala bentuk self-like, saling tukar like, membeli like, atau interaksi abnormal/palsu lainnya.
5. Memberikan informasi pribadi palsu atau mencuri informasi orang lain.
6. Perilaku lain yang dianggap oleh pihak penyelenggara melanggar keadilan event dan merugikan lingkungan game.

6) Klausul Force Majeure
Dalam hal terjadi force majeure di luar kendali pihak penyelenggara (termasuk namun tidak terbatas pada: perubahan kebijakan atau peraturan pemerintah, bencana alam, pandemi, perang, dll.), pihak penyelenggara berhak menyesuaikan jadwal event: memperpanjang, mempersingkat, atau menghentikan sementara event sesuai situasi, dengan pemberitahuan minimal 24 jam sebelumnya melalui situs resmi game atau halaman penggemar. Apabila terjadi force majeure mendadak (termasuk namun tidak terbatas pada: gangguan server parah, serangan siber, dll.) yang tidak memungkinkan pemberitahuan sebelumnya, pihak penyelenggara berkomitmen untuk segera memberikan pengumuman sesegera mungkin.

7) Penafian
1. Dengan berpartisipasi dalam event ini, pemain dianggap telah membaca, memahami, dan menyetujui seluruh aturan dan ketentuan event ini.
2. Anak di bawah umur atau orang dengan kapasitas hukum terbatas hanya boleh berpartisipasi dalam event ini setelah mendapat persetujuan dari wali sah mereka.
3. Semua catatan terkait event, termasuk perolehan poin, penggunaan poin, hasil undian, dan pemberian hadiah, menggunakan catatan sistem resmi penyelenggara sebagai acuan final.

※ Pihak resmi Ragnarok: The New World memiliki hak interpretasi final atas event ini, dan berhak dalam batas yang diizinkan hukum untuk menyesuaikan atau melengkapi konten, aturan, dan hadiah event sesuai situasi aktual. Konten terkait mengacu pada pengumuman resmi dari penyelenggara.`,
  rulePopupTitle: "Aturan Event",
  overTenTips: "Anda sudah menerbitkan 10 kali hari ini. Kembali besok!",
  rulePopupContent: ``,
  backText: "Kembali ke UGC",
  21000: "Belum login",
  21001: "Gagal mendapatkan URL upload",
  21002: "Gagal menggabungkan file",
  21003: "Jumlah slice tidak valid",
  21004: "Upload ID atau path tidak boleh kosong",
  21005: "Parameter error",
  21006: "Gagal mengirim konten",
  21007: "Like gagal",
  21008: "Gagal menghapus notifikasi",
  21010: "Terlalu banyak posting hari ini, coba besok",
  21011: "Terlalu banyak pengiriman hari ini, coba besok",
  21013: "Terlalu banyak pengiriman hari ini, coba besok",
  21014: "Format email tidak valid",
  21018: "Poin tidak cukup",
  21019: "Undian gagal",
  21022: "Event belum berakhir",
  21023: "Tidak ada hadiah fisik yang bisa diklaim",
  21024: "Gagal mengklaim hadiah fisik",
  21025: "Konten terlalu panjang",
  21026: "Anda masih memiliki poin untuk undian",
  21027: "Tidak ada hadiah virtual yang bisa diklaim",
  21028: "Catatan hadiah tidak ditemukan",
  21029: "Hadiah tidak milik pengguna ini",
  21030: "Bukan hadiah virtual",
  21031: "Hadiah belum diterima",
  viewMyRewardsBtn: "Lihat Hadiahku",
  claimRewardsBtn: "Klaim Hadiah",
  claimVirtualBtn: "Klaim Hadiah Virtual",
  claimPhysicalBtn: "Klaim Hadiah Fisik",
  myRewardsTitle: "Hadiahku",
  prizeNameLabel: "Nama Hadiah",
  prizeQtyLabel: "Jumlah Hadiah",
  obtainTimeLabel: "Waktu Diperoleh",
  currentStatusLabel: "Status Saat Ini",
  viewGiftCodeBtn: "Lihat Kode Paket",
  claimTips: "*Silakan kunjungi halaman ini untuk mengklaim selama periode beta game",
  congratulations: "Berhasil Mendapatkan",
  giftCodeLabel: "Kode Hadiah:",
  copyBtn: "Salin",
  copiedBtn: "Disalin",
  useGiftCodeTips: "Gunakan kode hadiah yang telah diklaim di dalam game",
  unclaimedStatus: "Belum diklaim",
  claimedStatus: "Diambil",
  oneDraw: "Gacha 1x",
  tenDraw: "Gacha 10x",
  lotteryPointCost: "Poin per undian: 25 poin",
  spendPointsFirst: "Habiskan poin dulu, setelah gacha selesai baru bisa ambil hadiah~",
  claimVirtualRewardSuccess: "Silakan cek [Hadiah Saya] untuk kode hadiah",
  submitting: "Mengirim...",
  submitSuccess: "Berhasil dikirim!",
  submitFailed: "Pengiriman gagal, silakan coba lagi",
  imageRequired: "Harap upload gambar",
  footerProvision: `
    <ol>
        <li>Game ini mengandung kekerasan, romansa, dan kostum yang menampilkan bentuk tubuh</li>
        <li>Beberapa konten memerlukan pembayaran tambahan</li>
        <li>Harap hindari bermain berlebihan</li>
    </ol>
  `,
  taskRulePopupTitle: "Penjelasan Aturan",
  taskRuleRules: `Aturan Event Undian Poin 《Ragnarok: The New World》

I. Periode Event
17 Juli 2026 pukul 00:00 – 24 Agustus 2026 pukul 23:59 (UTC+7)

II. Cara Mendapatkan Poin
1. Login pertama harian: 5 poin/hari, dibatasi 1 kali per hari.
2. Pra-registrasi: 25 poin, hanya dihitung sekali untuk registrasi pertama.
3. Ikuti akun media sosial resmi (Facebook, Discord, LINE, YouTube): 10 poin per platform, dibatasi 1 kali per platform.
4. Kirim masukan: 15 poin, hanya pengiriman pertama setiap hari yang dihitung.
5. Kirim karya ke event "Poring Saya": wajib kirim gambar, 25 poin, hanya pengiriman pertama setiap hari yang dihitung, maksimal 2 kali per minggu.
6. Kirim karya ke event "Berbagi Class": wajib kirim gambar, 25 poin, hanya pengiriman pertama setiap hari yang dihitung, maksimal 1 kali per minggu.
7. Kirim karya ke event "Berbagi Foto Keren": wajib kirim gambar, 25 poin, hanya pengiriman pertama setiap hari yang dihitung, maksimal 2 kali per minggu.
8. Like karya orang lain: 0,5 poin/like, hanya like pertama pada setiap karya yang dihitung; batalkan like lalu like lagi tidak akan mendapat poin tambahan. Hanya 10 like valid pertama per hari yang mendapat poin.
9. Karya mendapat like dari orang lain: 1 poin/like. Untuk mencegah kecurangan, satu akun hanya dapat memperoleh maksimal 200 poin per minggu melalui cara ini.
10. Akun yang melakukan like harus aktif dan valid. Sistem resmi memantau pola like yang tidak wajar. Pihak resmi berhak membatalkan poin yang diperoleh melalui kecurangan (termasuk namun tidak terbatas pada like sendiri dan grup saling like).
11. Jumlah partisipasi harian direset pukul 00:00 setiap hari; jumlah partisipasi mingguan direset pukul 00:00 setiap hari Senin.

III. Aturan Undian Poin
1. Pemain mendapatkan poin dengan berpartisipasi dalam event co-creation selama periode event. Setiap 25 poin dapat ditukarkan dengan 1 kali undian; setiap 250 poin dapat digunakan untuk 10 kali undian sekaligus. Poin hanya berlaku selama periode event undian dan akan kedaluwarsa setelah event berakhir.
2. Hadiah dan probabilitas:
- Tidak menang (20%)
- Item game: Headwear Eksklusif [Telinga Kucing Hitam] ×1 (2%)
- Item game: Bingkai Avatar Eksklusif [Co-Creation Planner] ×1 (3%)
- Item game: Gelar Eksklusif [Melempar Ranting Kering ke Perencana] ×1 (6%)
- Item game: Kotak Misteri Kafra ×1 (10%)
- Item game: Zeny Terikat ×3.000 (12%)
- Item game: Koin Petualangan ×10.000 (30%)
- Merchandise fisik: Fotocard Kolaborasi Limited BABYMONSTER (Set Lengkap) ×1 (1%)
- Merchandise fisik: Boneka Limited ×1 (3%)
- Merchandise fisik: Kartu Koleksi ×1 (4%)
- Merchandise fisik: Tas Ransel Kolaborasi ×1 (4%)
- Merchandise fisik: Tikar Piknik Petualangan ×1 (5%)

IV. Aturan Klaim Hadiah
1. Fitur klaim hadiah akan tersedia setelah event berakhir.
2. Aturan klaim hadiah virtual:
   1) Hadiah virtual yang diperoleh selama event dapat dilihat dengan mengklik "Lihat Hadiahku".
   2) Setelah event berakhir, pemain dapat mengklaim kode hadiah yang sesuai di halaman ini dan menukarkannya dalam game.
3. Aturan klaim hadiah fisik:
   1) Pemenang harus memberikan informasi pengiriman yang lengkap dan akurat di halaman event dalam 30 hari kerja setelah event berakhir. Penolakan atau keterlambatan pengiriman informasi akan dianggap sebagai pengunduran diri dari hadiah.
   2) Informasi pengiriman yang diperlukan: ① Nama lengkap ② Nomor telepon yang valid ③ Alamat lengkap termasuk nomor rumah ④ Kode pos.
   *Harap periksa semua informasi dengan teliti. Pihak resmi tidak bertanggung jawab atas kegagalan pengiriman, kehilangan, atau pengembalian hadiah akibat informasi yang salah, tidak lengkap, atau penerima tidak dapat dihubungi. Informasi pribadi yang diberikan hanya akan digunakan untuk pengiriman hadiah dan keperluan administrasi terkait; penyelenggara akan menjaga kerahasiaannya sesuai peraturan perundang-undangan yang berlaku.
   3) Pengiriman hadiah fisik: Diperkirakan akan selesai dikirim dalam 30–60 hari kerja setelah event berakhir. Harap bersabar.
   4) Perhatikan: event ini hanya terbuka untuk pemain di Thailand, Kamboja, Timor-Leste, Indonesia, Laos, Malaysia, Myanmar, Filipina, dan Singapura. Alamat pengiriman di luar wilayah tersebut akan dianggap sebagai pengunduran diri dari hadiah fisik.

V. Tanggung Jawab Pemain & Pengunduran Diri
1. Pemain bertanggung jawab untuk memantau aturan event dan semua tenggat waktu (periode event, periode mendapat/menukar poin, batas waktu pengiriman alamat, periode klaim hadiah virtual, dll.). Kegagalan untuk berpartisipasi, menukar undian, mengirimkan alamat pengiriman, atau mengklaim hadiah virtual dalam tenggat waktu resmi akan dianggap sebagai pengunduran diri otomatis dari hak terkait.
2. Semua kerugian akibat pengunduran diri (termasuk namun tidak terbatas pada kedaluwarsa poin dan hadiah yang tidak diklaim) adalah tanggung jawab pemain sendiri. Pihak resmi tidak berkewajiban memberikan kompensasi atau pemulihan dalam bentuk apapun.

VI. Hak Cipta Konten & Penggunaan
Dengan mengirimkan karya, Anda memberikan kepada pihak resmi game lisensi yang berlaku di seluruh dunia, permanen, tidak dapat dicabut, bebas royalti untuk digunakan di dalam dan di luar game, termasuk pemasaran, promosi, adaptasi, dan karya turunan. Pihak resmi berhak memodifikasi, mengoptimalkan, memproduksi, dan mereproduksi kiriman Anda serta menggunakannya dalam game, merchandise game, promosi pasar, dan kegiatan terkait.

VII. Anti-Kecurangan & Penanganan Pelanggaran
Pihak resmi secara ketat memantau perilaku partisipasi event. Setelah terdeteksi pelanggaran berikut, pihak resmi berhak segera mengambil tindakan termasuk namun tidak terbatas pada pemblokiran akun yang terlibat, pencabutan semua kelayakan event, penarikan kembali hadiah yang telah didistribusikan (termasuk item virtual yang telah digunakan), dan penuntutan hukum:
1. Pembuatan massal akun alternatif (orang yang sama, perangkat yang sama, multi-akun IP yang sama) untuk berpartisipasi dalam event.
2. Menggunakan eksploitasi, alat tidak resmi, atau cara tidak normal apapun untuk menambang poin.
3. Menggunakan perangkat lunak pihak ketiga ilegal, cheat, atau alat bantu untuk mengganggu event.
4. Segala bentuk like sendiri, saling like, membeli like, atau perilaku interaksi tidak normal/palsu lainnya.
5. Memberikan informasi pribadi palsu atau menyalahgunakan informasi orang lain.
6. Perilaku lain yang dianggap oleh pihak resmi melanggar keadilan event atau merugikan lingkungan game.

VIII. Keadaan Kahar
Dalam hal terjadi keadaan kahar di luar kendali pihak resmi (termasuk namun tidak terbatas pada: perubahan kebijakan pemerintah, bencana alam, epidemi, perang), pihak resmi berhak menyesuaikan jadwal event — memperpanjang, mempersingkat, atau menangguhkan event — dengan pemberitahuan setidaknya 24 jam sebelumnya di situs web resmi atau halaman penggemar. Dalam hal keadaan kahar mendadak (termasuk namun tidak terbatas pada: kegagalan server besar, serangan peretas) yang tidak memungkinkan pemberitahuan awal, pihak resmi berkomitmen untuk mengumumkan sesegera mungkin.

IX. Penafian
Dengan berpartisipasi dalam event ini, Anda menegaskan bahwa Anda telah sepenuhnya membaca, memahami, dan menyetujui hal-hal berikut:
1. Jika Anda adalah anak di bawah umur atau orang dengan kapasitas hukum terbatas, Anda telah mendapatkan persetujuan dari wali hukum Anda sebelum berpartisipasi.
2. Pengunduran diri karena lewat batas waktu: kegagalan menyelesaikan tindakan yang diperlukan dalam kerangka waktu yang ditentukan resmi (periode penukaran poin, batas waktu pengiriman alamat, periode klaim hadiah virtual, dll.) akan dianggap sebagai pengunduran diri otomatis dari hak terkait.
3. Tanggung jawab atas kesalahan informasi: pihak resmi tidak bertanggung jawab atas ketidakmampuan mendapatkan poin, berpartisipasi dalam undian, menerima hadiah, atau kerugian apapun yang disebabkan oleh informasi pribadi yang salah, palsu, kedaluwarsa, atau tidak diperbarui tepat waktu (termasuk namun tidak terbatas pada informasi pengiriman dan informasi akun) yang diberikan oleh pemain.
4. Tanggung jawab atas keamanan & status akun: pihak resmi tidak bertanggung jawab atas ketidakmampuan berpartisipasi dalam event, kehilangan poin, hadiah yang tidak diklaim, atau kerugian apapun yang disebabkan oleh peretasan akun, masalah perangkat pribadi, masalah jaringan, atau penangguhan akun akibat pelanggaran aturan game. Jika akun ditangguhkan selama event, poin yang belum digunakan dan hadiah yang belum didistribusikan akan otomatis dianggap hangus.
5. Catatan sistem adalah otoritatif: semua catatan perolehan poin, penggunaan poin, undian, dan kemenangan tunduk pada data akhir dalam sistem backend resmi.

※ 《Ragnarok: The New World》 berhak atas interpretasi akhir event ini dan dapat, dalam batas yang diizinkan oleh hukum, menyesuaikan atau melengkapi konten event, aturan, dan hadiah berdasarkan kondisi aktual. Pengumuman resmi yang berlaku.`,
  rulePopupContent: ``,
  createPopupTip: "Dengan mengirimkan, Anda memberikan lisensi global, permanen, tidak dapat dicabut, bebas royalti kepada pihak game resmi untuk digunakan di dalam dan di luar game termasuk pemasaran, promosi, adaptasi dan karya turunan.",
  checkTermsTip: 'Silakan setujui ketentuan otorisasi',
  imageUploadingTip: 'Gambar sedang diunggah, harap tunggu',
  imageSizeTip: 'Ukuran gambar tidak boleh melebihi 10MB',
  imageFormatTip: 'Hanya format JPG dan PNG yang didukung',
  imageMaxTip: 'Maksimal 3 gambar yang dapat diunggah',
  imageUploadFailTip: 'Gagal mengunggah gambar, silakan coba lagi',
  saveConfirmMessage: 'Apakah Anda ingin menyimpan hasil edit ini?',
  footerRatingLines: ['Game ini mengandung konten kekerasan dan romansa', 'Sebagian konten memerlukan pembayaran tambahan', 'Harap hindari bermain game secara berlebihan'],
  footerTermsText: 'Ketentuan Layanan',
  footerPrivacyText: 'Kebijakan Privasi',
  awardThanks: 'Terima Kasih',
  awardTitle: 'Gelar Kustom [Melempar Dead Branch ke Developer]*1',
  awardAvatar: 'Bingkai Avatar Kustom [Co-Creator Planner]*1',
  awardHeadwear: 'Headwear Kustom [Black Cat Ears]*1',
  awardBlindbox: 'Blind Box Kafra*1',
  awardZeny: 'Zeny Terikat*3000',
  awardCoin: 'Adventure Coin*10000',
  awardDoll: 'Plush Terbatas',
  awardCard: 'Kartu Koleksi',
  awardTshirt: 'Kaos ROW',
  awardBackpack: 'Tas Ransel Kolaborasi',
  awardPhotocard: 'Set Lengkap Photocard Terbatas Kolaborasi BABYMONSTER',
  awardPhoneHolder: 'Dudukan HP Baphomet',
  awardCanvasBag: 'Tas Kanvas New World',
  awardFridgeMagnet: 'Magnet Kulkas Novice',
  awardWaistPillow: 'Bantal Punggung RO',
  scoreTitleNone: 'Tidak Ada',
  scoreTitleLv1: 'Pemula dengan Ide Liar',
  scoreTitleLv2: 'Investasi RO World Pasti Untung',
  scoreTitleLv3: 'Tidak Lagi Berpura-pura, Akulah Sang Pencipta',
  footerTermsUrl: 'https://www.gnjoy.hk/Terms',
  footerPrivacyUrl: 'https://www.gnjoy.hk/Policies',
};
